/**
 * FAQ accordion: only one item open at a time within each list.
 */
class FaqAccordion extends HTMLElement {
  connectedCallback() {
    this.items = Array.from(this.querySelectorAll('details.faq-product__item'));
    if (!this.items.length) return;

    this.items.forEach((detail) => {
      detail.addEventListener('toggle', () => this.onToggle(detail));
    });
  }

  onToggle(detail) {
    if (!detail.open) return;

    this.items.forEach((other) => {
      if (other === detail || !other.open) return;
      other.removeAttribute('open');
      other.classList.remove('has-opened');
      const summary = other.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', 'false');
    });
  }
}

if (!customElements.get('faq-accordion')) {
  customElements.define('faq-accordion', FaqAccordion);
}
